import { Action, Dispatch } from 'redux';
import {
  RequestId,
  CSAT_ELIGIBILITY_URL,
  API_DEFAULT_RETRIES,
  CSAT_SUBMIT_URL,
  CSAT,
  CTUI,
  KEVALIN_COLLECTIONS,
  CSAT_EVENT_CATEGORIES,
  CSAT_EVENT_TYPES,
} from 'appConstants';
import { ApiRequest, BrowserUtils, KevalinUtils } from 'services';
import { CSATFeedback, CSATFeedbackKevalin, SurveyEligility } from 'types';

export interface CsatAction extends Action {
  comment?: string;
  score?: number | undefined;
  visibility?: boolean;
  successState?: boolean;
  csatEligible?: boolean;
  submitSuccessSurvey?: boolean;
  _isSuccessSubmitSurvey?: boolean;
  _isErrorSubmitSurvey?: boolean;
  isLoading?: boolean;
  isEligible?: boolean;
  selectedRating?: string;
  selectedFactor?: Array<string>;
  surveyChecked?: boolean;
}

export interface RatingCSAT {
  readonly _isCsatVisible: boolean;
  readonly _isSuccessState: boolean;
  readonly comment: string;
  readonly choice: string;
  readonly score: number | undefined;
  readonly csatEligible: boolean;
  readonly _isSuccessSubmitSurvey: boolean;
  readonly _isErrorSubmitSurvey: boolean;
  readonly isLoading: boolean;
  readonly isEligible: boolean;
  readonly selectedRating: string;
  readonly selectedFactor: Array<string>;
  readonly surveyChecked?: boolean;
}

/* Initial State */

const initialState = {
  _isCsatVisible: false,
  _isSuccessState: false,
  comment: '',
  choice: '',
  score: undefined,
  csatEligible: false,
  _isSuccessSubmitSurvey: false,
  _isErrorSubmitSurvey: false,
  isLoading: false,
  isEligible: false,
  selectedRating: '',
  selectedFactor: [],
  surveyChecked: false,
} as RatingCSAT;

/* Actions */

enum CsatActions {
  RESET_CSAT = 'RESET_CSAT',
  SET_CSAT_COMMENT = 'SET_CSAT_COMMENT',
  SET_CSAT_SCORE = 'SET_CSAT_SCORE',
  SET_CSAT_PANEL_VISIBILITY = 'SET_CSAT_MODAL_VISIBILITY',
  SET_CSAT_PANEL_STATE = 'SET_CSAT_PANEL_STATE',
  SHOW_SURVEY_ELIGILBILITY_ERROR = 'SHOW_SURVEY_ELIGILBILITY_ERROR',
  SET_SURVEY_ELIGIBILITY = 'SET_SURVEY_ELIGIBILITY',
  SET_SUCCESS_SUBMIT_SURVEY = 'SET_SUCCESS_SUBMIT_SURVEY',
  SET_ERROR_SUBMIT_SURVEY = 'SET_ERROR_SUBMIT_SURVEY',
  LOADING = 'LOADING',
  SET_CSAT_RATING = 'SET_CSAT_RATING',
  SET_CSAT_FACTOR = 'SET_CSAT_FACTOR',
  SET_SURVEY_CHECKED = 'SET_SURVEY_CHECKED',
}

const setSurveyEligibility = (isEligible: boolean): CsatAction => ({
  type: CsatActions.SET_SURVEY_ELIGIBILITY,
  isEligible,
});

const showSurveyEligibilityrror = (): CsatAction => ({
  type: CsatActions.SHOW_SURVEY_ELIGILBILITY_ERROR,
});

const resetCsat = (): CsatAction => ({
  type: CsatActions.RESET_CSAT,
});

const setCsatComment = (comment: string): CsatAction => ({
  type: CsatActions.SET_CSAT_COMMENT,
  comment,
});

const setCsatScore = (score: number): CsatAction => ({
  type: CsatActions.SET_CSAT_SCORE,
  score,
});

const showCsatSurvey = (visibility: boolean): CsatAction => ({
  type: CsatActions.SET_CSAT_PANEL_VISIBILITY,
  visibility,
});

const setCsatPanelState = (successState: boolean): CsatAction => ({
  type: CsatActions.SET_CSAT_PANEL_STATE,
  successState,
});

const setSucessSubmitSurveyState = (
  _isSuccessSubmitSurvey: boolean,
): CsatAction => ({
  type: CsatActions.SET_SUCCESS_SUBMIT_SURVEY,
  _isSuccessSubmitSurvey,
});

const setErrorSubmitSurveyState = (
  _isErrorSubmitSurvey: boolean,
): CsatAction => ({
  type: CsatActions.SET_ERROR_SUBMIT_SURVEY,
  _isErrorSubmitSurvey,
});

const setLoadingState = (isLoading: boolean): CsatAction => ({
  type: CsatActions.LOADING,
  isLoading,
});

const setSelectedRating = (selectedRating: string): CsatAction => ({
  type: CsatActions.SET_CSAT_RATING,
  selectedRating,
});

const setSelectedFactor = (selectedFactor: Array<string>): CsatAction => ({
  type: CsatActions.SET_CSAT_FACTOR,
  selectedFactor,
});

const setSurveyChecked = (surveyChecked: boolean): CsatAction => ({
  type: CsatActions.SET_SURVEY_CHECKED,
  surveyChecked,
});
/* Reducer */

const customerSatisfactionSurveyReducer = (
  state = initialState,
  action: CsatAction,
) => {
  switch (action.type) {
    case CsatActions.SET_CSAT_COMMENT:
      return {
        ...state,
        comment: action.comment,
      };
    case CsatActions.SET_CSAT_SCORE:
      return {
        ...state,
        score: action.score,
      };
    case CsatActions.RESET_CSAT:
      return {
        ...state,
        score: undefined,
        comment: '',
        _isSuccessState: false,
      };
    case CsatActions.SET_CSAT_PANEL_STATE:
      return {
        ...state,
        _isSuccessState: action.successState,
      };
    case CsatActions.SET_CSAT_PANEL_VISIBILITY:
      return {
        ...state,
        _isCsatVisible: action.visibility,
      };
    case CsatActions.SET_SURVEY_ELIGIBILITY:
      return {
        ...state,
        isEligible: action.isEligible,
      };
    case CsatActions.SET_SUCCESS_SUBMIT_SURVEY:
      return {
        ...state,
        _isSuccessSubmitSurvey: action._isSuccessSubmitSurvey,
      };
    case CsatActions.SET_ERROR_SUBMIT_SURVEY:
      return {
        ...state,
        _isErrorSubmitSurvey: action._isErrorSubmitSurvey,
      };
    case CsatActions.LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case CsatActions.SET_CSAT_RATING:
      return {
        ...state,
        selectedRating: action.selectedRating,
      };
    case CsatActions.SET_CSAT_FACTOR:
      return {
        ...state,
        selectedFactor: action.selectedFactor,
      };
    case CsatActions.SET_SURVEY_CHECKED:
      return {
        ...state,
        surveyChecked: action.surveyChecked,
      };
    default:
      return state;
  }
};

/** GET survey eligibility */
const surveyEligibility = () => async (dispatch: Dispatch<CsatAction>) => {
  const onError = () => {
    dispatch(showSurveyEligibilityrror());
  };

  const onSuccess = (response: SurveyEligility) => {
    dispatch(setSurveyEligibility(response.isEligible));
  };

  return ApiRequest.get(`${CSAT_ELIGIBILITY_URL}`, {
    dispatchId: RequestId.GET_CSAT_ELIGIBLITY,
    onSuccess,
    onError,
  });
};

const storeCSATToKevlin = (
  ticketId: string,
  accountId: string,
  factors: Array<string>,
  rating: string,
  comment: string,
  didFailed: boolean,
  ratingType: Number,
) => async (dispatch: Dispatch<CsatAction>) => {
  const feedback: CSATFeedbackKevalin = {
    feedback: {
      rating: rating,
      factors: factors,
      comment: comment,
      didFailed: didFailed,
      ratingType: ratingType,
    },
  };
  const payload = {
    eventData: {
      portal: CTUI,
      surveyType: CSAT,
      username: window.PORTAL_DATA.username,
      domainId: window.PORTAL_DATA.domainId,
      accountType: window.PORTAL_DATA.domainId.includes('dedicated')
        ? 'dedicated'
        : 'cloud',
      accountId: accountId,
      referrer: window.location.href,
      userAgent: BrowserUtils.getBrowserDetails(),
      relatedEvents: KevalinUtils.getRelatedEvents(
        CSAT_EVENT_TYPES.TICKET,
        CSAT_EVENT_CATEGORIES.SERVICE,
        [ticketId],
        CTUI,
      ),
      ...feedback,
    },
  };
  return ApiRequest.post(
    KevalinUtils.getKevalinURL(KEVALIN_COLLECTIONS.CSAT),
    payload,
    {
      retries: API_DEFAULT_RETRIES,
    },
  );
};

const storeCSATSurvey = (
  ticketId: string,
  accountId: string,
  factors: Array<string>,
  rating: string,
  comment: string,
  ratingType: Number,
) => async (dispatch: Dispatch<CsatAction>) => {
  const surveyFeedback: CSATFeedback = {
    feedback: {
      rating: rating,
      factors: factors,
      comment: comment,
    },
  };
  const payload = {
    type: ratingType,
    ticketID: ticketId,
    accountID: accountId,
    ...(surveyFeedback.feedback.rating && surveyFeedback),
  };
  const onError = () => {
    dispatch(setErrorSubmitSurveyState(true));
    dispatch(
      storeCSATToKevlin(
        ticketId,
        accountId,
        factors,
        rating,
        comment,
        true,
        ratingType,
      ),
    );
  };

  const onSuccess = (response: object) => {
    if (response) {
      dispatch(setSucessSubmitSurveyState(true));
      dispatch(setSurveyEligibility(false));
      dispatch(
        storeCSATToKevlin(
          ticketId,
          accountId,
          factors,
          rating,
          comment,
          false,
          ratingType,
        ),
      );
    }
  };
  return ApiRequest.post(CSAT_SUBMIT_URL, payload, {
    retries: API_DEFAULT_RETRIES,
    onError,
    onSuccess,
  });
};

export {
  CsatActions,
  customerSatisfactionSurveyReducer,
  resetCsat,
  setCsatComment,
  setCsatScore,
  setCsatPanelState,
  showCsatSurvey,
  surveyEligibility,
  setSurveyEligibility,
  storeCSATSurvey,
  storeCSATToKevlin,
  setSucessSubmitSurveyState,
  setErrorSubmitSurveyState,
  setLoadingState,
  setSelectedRating,
  setSelectedFactor,
  setSurveyChecked,
};
